import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { HideIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const RestrictedPropertyIcon = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crm_components.PropertyListEditor.restrictedPropertyTooltip"
    }),
    use: "longform",
    children: /*#__PURE__*/_jsx(HideIcon, {
      color: "text-core-disabled",
      size: "400"
    })
  });
};
export default RestrictedPropertyIcon;